import $ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete';

$(() => {
  const el = $('[data-behavior=autocomplete]');
  el.autocomplete({
    source: el.data('source'),
  });
});
